/**
 * React Query Hook for Languages
 * Fetches and caches active languages
 */

import { useQuery } from '@tanstack/react-query';
import { languagesService } from '../services/languages.service';

/**
 * Query Keys
 */
export const languagesKeys = {
  all: ['languages'] as const,
};

/**
 * Hook: Get all active languages
 * Cached for 24 hours - fetched once per session
 * Predefined languages are stable and rarely change
 */
export function useLanguagesQuery() {
  return useQuery({
    queryKey: languagesKeys.all,
    queryFn: () => languagesService.getAll(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours - languages rarely change
    gcTime: 1000 * 60 * 60 * 24 * 7, // 7 days - keep in cache even longer
  });
}
